import { useTheme } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import type { CustomSvgIconsProps, SvgPathProps } from './CustomSvgIcons.types';
import { viewBoxes } from './CustomSvgIcons.types';

const SvgPath = ({ iconType, shapeId }: SvgPathProps): React.ReactElement => {
  if (iconType === 'bold') {
    return (
      <path
        d="M5.75 14C5.75 14.4142 6.08579 14.75 6.5 14.75C6.91421 14.75 7.25 14.4142 7.25 14H5.75ZM6.5 10L7.136 9.6025C6.95867 9.31878 6.61485 9.18682 6.29324 9.27906C5.97162 9.3713 5.75 9.66542 5.75 10H6.5ZM9 14L8.364 14.3975C8.54133 14.6812 8.88515 14.8132 9.20676 14.7209C9.52838 14.6287 9.75 14.3346 9.75 14H9ZM9.75 10C9.75 9.58579 9.41421 9.25 9 9.25C8.58579 9.25 8.25 9.58579 8.25 10H9.75ZM10.75 14C10.75 14.4142 11.0858 14.75 11.5 14.75C11.9142 14.75 12.25 14.4142 12.25 14H10.75ZM13 12.75C13.4142 12.75 13.75 12.4142 13.75 12C13.75 11.5858 13.4142 11.25 13 11.25V12.75ZM11.5 10V9.25C11.0858 9.25 10.75 9.58579 10.75 10H11.5ZM13.5 10.75C13.9142 10.75 14.25 10.4142 14.25 10C14.25 9.58579 13.9142 9.25 13.5 9.25V10.75ZM15.75 14C15.75 14.4142 16.0858 14.75 16.5 14.75C16.9142 14.75 17.25 14.4142 17.25 14H15.75ZM15.5 9.25C15.0858 9.25 14.75 9.58579 14.75 10C14.75 10.4142 15.0858 10.75 15.5 10.75V9.25ZM17.5 10.75C17.9142 10.75 18.25 10.4142 18.25 10C18.25 9.58579 17.9142 9.25 17.5 9.25V10.75ZM7.25 14V10H5.75V14H7.25ZM5.864 10.3975L8.364 14.3975L9.636 13.6025L7.136 9.6025L5.864 10.3975ZM9.75 14V10H8.25V14H9.75ZM12.25 14V12H10.75V14H12.25ZM11.5 12.75H13V11.25H11.5V12.75ZM12.25 12V10H10.75V12H12.25ZM11.5 10.75H13.5V9.25H11.5V10.75ZM17.25 14V10H15.75V14H17.25ZM16.5 9.25H15.5V10.75H16.5V9.25ZM16.5 10.75H17.5V9.25H16.5V10.75ZM20.25 12C20.25 16.5563 16.5563 20.25 12 20.25V21.75C17.3848 21.75 21.75 17.3848 21.75 12H20.25ZM12 20.25C7.44365 20.25 3.75 16.5563 3.75 12H2.25C2.25 17.3848 6.61522 21.75 12 21.75V20.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75V2.25C6.61522 2.25 2.25 6.61522 2.25 12H3.75ZM12 3.75C16.5563 3.75 20.25 7.44365 20.25 12H21.75C21.75 6.61522 17.3848 2.25 12 2.25V3.75Z"
        id={shapeId}
      />
    );
  } else if (iconType === 'normal') {
    return (
      <path
        d="M10.2333 23.3333C10.2333 23.6647 10.502 23.9333 10.8333 23.9333C11.1647 23.9333 11.4333 23.6647 11.4333 23.3333H10.2333ZM10.8333 16.6667L11.3421 16.3487C11.2003 16.1217 10.9252 16.0161 10.6679 16.0899C10.4106 16.1637 10.2333 16.399 10.2333 16.6667H10.8333ZM15 23.3333L14.4912 23.6513C14.6331 23.8783 14.9081 23.9839 15.1654 23.9101C15.4227 23.8363 15.6 23.601 15.6 23.3333H15ZM15.6 16.6667C15.6 16.3353 15.3314 16.0667 15 16.0667C14.6686 16.0667 14.4 16.3353 14.4 16.6667H15.6ZM18.5667 23.3333C18.5667 23.6647 18.8353 23.9333 19.1667 23.9333C19.498 23.9333 19.7667 23.6647 19.7667 23.3333H18.5667ZM21.6667 20.6C21.998 20.6 22.2667 20.3314 22.2667 20C22.2667 19.6686 21.998 19.4 21.6667 19.4V20.6ZM19.1667 16.6667V16.0667C18.8353 16.0667 18.5667 16.3353 18.5667 16.6667H19.1667ZM22.5 17.2667C22.8314 17.2667 23.1 16.998 23.1 16.6667C23.1 16.3353 22.8314 16.0667 22.5 16.0667V17.2667ZM26.9 23.3333C26.9 23.6647 27.1686 23.9333 27.5 23.9333C27.8314 23.9333 28.1 23.6647 28.1 23.3333H26.9ZM25.8333 16.0667C25.502 16.0667 25.2333 16.3353 25.2333 16.6667C25.2333 16.998 25.502 17.2667 25.8333 17.2667V16.0667ZM29.1667 17.2667C29.498 17.2667 29.7667 16.998 29.7667 16.6667C29.7667 16.3353 29.498 16.0667 29.1667 16.0667V17.2667ZM11.4333 23.3333V16.6667H10.2333V23.3333H11.4333ZM10.3245 16.9847L14.4912 23.6513L15.5088 23.0153L11.3421 16.3487L10.3245 16.9847ZM15.6 23.3333V16.6667H14.4V23.3333H15.6ZM19.7667 23.3333V20H18.5667V23.3333H19.7667ZM19.1667 20.6H21.6667V19.4H19.1667V20.6ZM19.7667 20V16.6667H18.5667V20H19.7667ZM19.1667 17.2667H22.5V16.0667H19.1667V17.2667ZM28.1 23.3333V16.6667H26.9V23.3333H28.1ZM27.5 16.0667H25.8333V17.2667H27.5V16.0667ZM27.5 17.2667H29.1667V16.0667H27.5V17.2667ZM34.4 20C34.4 27.9529 27.9529 34.4 20 34.4V35.6C28.6156 35.6 35.6 28.6156 35.6 20H34.4ZM20 34.4C12.0471 34.4 5.6 27.9529 5.6 20H4.4C4.4 28.6156 11.3844 35.6 20 35.6V34.4ZM5.6 20C5.6 12.0471 12.0471 5.6 20 5.6V4.4C11.3844 4.4 4.4 11.3844 4.4 20H5.6ZM20 5.6C27.9529 5.6 34.4 12.0471 34.4 20H35.6C35.6 11.3844 28.6156 4.4 20 4.4V5.6Z"
        id={shapeId}
      />
    );
  } else {
    return (
      <path
        d="M21.0667 46.6667C21.0667 46.998 21.3353 47.2667 21.6667 47.2667C21.998 47.2667 22.2667 46.998 22.2667 46.6667H21.0667ZM21.6667 33.3333L22.1755 33.0153C22.0336 32.7884 21.7586 32.6828 21.5013 32.7566C21.244 32.8304 21.0667 33.0657 21.0667 33.3333H21.6667ZM30 46.6667L29.4912 46.9847C29.6331 47.2116 29.9081 47.3172 30.1654 47.2434C30.4227 47.1696 30.6 46.9343 30.6 46.6667H30ZM30.6 33.3333C30.6 33.002 30.3314 32.7333 30 32.7333C29.6686 32.7333 29.4 33.002 29.4 33.3333H30.6ZM37.7333 46.6667C37.7333 46.998 38.002 47.2667 38.3333 47.2667C38.6647 47.2667 38.9333 46.998 38.9333 46.6667H37.7333ZM43.3333 40.6C43.6647 40.6 43.9333 40.3314 43.9333 40C43.9333 39.6686 43.6647 39.4 43.3333 39.4V40.6ZM38.3333 33.3333V32.7333C38.002 32.7333 37.7333 33.002 37.7333 33.3333H38.3333ZM45 33.9333C45.3314 33.9333 45.6 33.6647 45.6 33.3333C45.6 33.002 45.3314 32.7333 45 32.7333V33.9333ZM54.4 46.6667C54.4 46.998 54.6686 47.2667 55 47.2667C55.3314 47.2667 55.6 46.998 55.6 46.6667H54.4ZM51.6667 32.7333C51.3353 32.7333 51.0667 33.002 51.0667 33.3333C51.0667 33.6647 51.3353 33.9333 51.6667 33.9333V32.7333ZM58.3333 33.9333C58.6647 33.9333 58.9333 33.6647 58.9333 33.3333C58.9333 33.002 58.6647 32.7333 58.3333 32.7333V33.9333ZM22.2667 46.6667V33.3333H21.0667V46.6667H22.2667ZM21.1579 33.6513L29.4912 46.9847L30.5088 46.3487L22.1755 33.0153L21.1579 33.6513ZM30.6 46.6667V33.3333H29.4V46.6667H30.6ZM38.9333 46.6667V40H37.7333V46.6667H38.9333ZM38.3333 40.6H43.3333V39.4H38.3333V40.6ZM38.9333 40V33.3333H37.7333V40H38.9333ZM38.3333 33.9333H45V32.7333H38.3333V33.9333ZM55.6 46.6667V33.3333H54.4V46.6667H55.6ZM55 32.7333H51.6667V33.9333H55V32.7333ZM55 33.9333H58.3333V32.7333H55V33.9333ZM69.4 40C69.4 56.2372 56.2372 69.4 40 69.4V70.6C56.8999 70.6 70.6 56.8999 70.6 40H69.4ZM40 69.4C23.7628 69.4 10.6 56.2372 10.6 40H9.4C9.4 56.8999 23.1001 70.6 40 70.6V69.4ZM10.6 40C10.6 23.7628 23.7628 10.6 40 10.6V9.4C23.1001 9.4 9.4 23.1001 9.4 40H10.6ZM40 10.6C56.2372 10.6 69.4 23.7628 69.4 40H70.6C70.6 23.1001 56.8999 9.4 40 9.4V10.6Z"
        id={shapeId}
      />
    );
  }
};
export const NftIcon = ({
  shouldbegradient,
  transitionduration = 0.4,
  prefix,
  solidColor,
  iconType = 'normal',
  gradientColor,
  ...props
}: CustomSvgIconsProps): React.ReactElement => {
  const currColorId = `${prefix}_nftCurrentColorGradient`;
  const newColorId = `${prefix}_nftNewColorGradient`;
  const shapeId = `${prefix}_nftShape`;
  const theme = useTheme();
  const isLight = theme.palette.type === 'light';
  const colorsDark = {
    base: {
      start: theme.palette?.greyColors?.PLUS_8,
      stop: theme.palette.greyColors?.PLUS_2,
    },
    hover: {
      start: theme.palette?.greyColors?.PLUS_8,
      stop: theme.palette.violetColors?.PLUS_2,
    },
  };
  const colorsLight = {
    base: {
      start: theme.palette?.greyColors?.PLUS_4,
      stop: theme.palette.greyColors?.PLUS_2,
    },
    hover: {
      start: theme.palette?.violetColors?.PLUS_3,
      stop: theme.palette.violetColors?.PLUS_2,
    },
  };
  const svgColors = isLight ? colorsLight : colorsDark;
  return (
    <SvgIcon {...props} viewBox={viewBoxes[iconType]}>
      {solidColor ? (
        <SvgPath
          shapeId={shapeId}
          iconType={iconType}
          solidColor={solidColor}
        />
      ) : (
        <>
          <defs>
            <linearGradient
              style={{
                transition: `${transitionduration}s`,
              }}
              id={currColorId}
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%">
              <stop offset="0" stopColor={svgColors.base.start} />
              <stop offset="1" stopColor={svgColors.base.stop} />
            </linearGradient>
            <linearGradient id={newColorId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0" stopColor={svgColors.hover.start} />
              <stop offset="1" stopColor={svgColors.hover.stop} />
            </linearGradient>
          </defs>
          <g
            style={{
              fill: `url("#${currColorId}")`,
            }}>
            <SvgPath
              shapeId={shapeId}
              iconType={iconType}
              solidColor={solidColor}
            />
          </g>
          <use
            xlinkHref={`#${shapeId}`}
            style={{
              fill: `url("#${newColorId}")`,
              transition: `${transitionduration}s`,
              opacity: shouldbegradient ? 1 : 0,
            }}
          />{' '}
        </>
      )}
    </SvgIcon>
  );
};
